export default "__VITE_ASSET__nBMDHisz__"